module.exports = __webpack_public_path__ + "img/visa-img1@2x.e726cf60.png";